export default "/profile/images/SalesDrive.svg?3f8eec3d096331c5a557726bb9528573";